// extracted by mini-css-extract-plugin
export var actionButton = "_a0-0";
export var attachmentLine = "_a0-1";
export var fileInput = "_a0-2";
export var fileUploadWrapper = "_a0-4";
export var footer = "_a0-3";
export var modalContent = "_a0-5";
export var paperclip = "_a0-6";
export var quillEditor = "_a0-7";